export const userCookies = {
  C_ID: 'c_id',
  CONTACT_UUID: 'contact_uuid',
  CURRENCY_RATE: 'currency_rate',
  NEWSLETTER_SIGNUP: 'newsletter_signup',
  CONSENT_STATUS: 'consent_status',
  REWARDS_VISIBILITY_ALREADY_TRACKED: 'rewards_visibility_already_tracked'
};

export const clientCookies = {
  PRODUCT_ANALYTICS_CLIENT_ID: 'pa_client_id',
  PRODUCT_ANALYTICS_USER_ID: 'pa_user_id',
  POSTHOG_API_KEY: 'posthog_api_key',
  POSTHOG_API_HOST: 'posthog_api_host'
};
